import {getMortgageById, getMortgages, patchMortgage, postMortgage} from "@/services/brokerService";

const deepEqual = require("deep-equal");

export default {
  namespaced: true,
  state: {
    mortgageRefresh: true,
    filters: {
      created__gte: null,
      created__lt: null,
      page_size: 10,
      financnik: null,
      search: null,
      active_service: null,
    },
    pages: {
      prehrana: 1,
      zrusena: 1,
      pozastavena: 1,
      vyber_riesenia: 1,
      podpis_ziadosti: 1,
      kompletizacia_podkladov: 1,
      schvalovanie: 1,
      servis: 1,
      cerpana: 1,
    },
    mortgages: {
      prehrana: [],
      zrusena: [],
      pozastavena: [],
      vyber_riesenia: [],
      podpis_ziadosti: [],
      kompletizacia_podkladov: [],
      schvalovanie: [],
      servis: [],
      cerpana: [],
    },
    mortgagesCount: {
      prehrana: 0,
      zrusena: 0,
      pozastavena: 0,
      vyber_riesenia: 0,
      podpis_ziadosti: 0,
      kompletizacia_podkladov: 0,
      schvalovanie: 0,
      servis: 0,
      cerpana: 0,
    },
  },
  getters: {
    getMortgages: (state) => {
      return state.mortgages;
    },
    getMortgagesCount: (state) => {
      return state.mortgagesCount;
    },
    getMortgagesByApplicant(state) {
      return (applicant) => {
        const applicantMortgages = [];

        for (const mortgages of Object.values(state.mortgages)) {
          for (const mortgage of mortgages) {
            if (mortgage.applicant === applicant) {
              applicantMortgages.push(mortgage);
            }
          }
        }

        return applicantMortgages;
      }
    },
  },
  mutations: {
    setRefreshMortgageAuto: (state, value) => {
      state.mortgageRefresh = value;
    },
    registerNewMortgage: (state, mortgage) => {
      const mortgagesUpdated = JSON.parse(JSON.stringify(state.mortgages));
      mortgagesUpdated[mortgage.stage].unshift(mortgage);
      state.mortgages = mortgagesUpdated;
    },
    attachNextPageMortgages: (state, mortgageInfo) => {
      const mortgagesUpdated = JSON.parse(JSON.stringify(state.mortgages));
      let mortgagesStageUpdated = mortgagesUpdated[mortgageInfo.stage];
      mortgagesStageUpdated = [...mortgagesStageUpdated, ...mortgageInfo.results];
      mortgagesUpdated[mortgageInfo.stage] = mortgagesStageUpdated;
      state.mortgages = mortgagesUpdated;
    },
    updateMortgage: (state, mortgageInfo) => {
      const mortgagesUpdated = JSON.parse(JSON.stringify(state.mortgages));
      const mortgagesStageUpdated = mortgagesUpdated[mortgageInfo.stage];
      const index = mortgagesStageUpdated.map((mortgage) => {
        return mortgage.id
      }).indexOf(mortgageInfo.mortgage.id);
      mortgagesStageUpdated[index] = mortgageInfo.mortgage;
      state.mortgages = mortgagesUpdated;
    },
    setMortgages: (state, mortgages) => {
      const mortgagesUpdated = JSON.parse(JSON.stringify(state.mortgages));
      mortgagesUpdated[mortgages.stage] = mortgages.results;
      state.mortgages = mortgagesUpdated;
    },
    switchMortgageBetweenStages: (state, mortgage) => {
      const mortgagesUpdated = JSON.parse(JSON.stringify(state.mortgages));
      const oldMortgageStage = mortgagesUpdated[mortgage.stage_old];
      const oldIndex = oldMortgageStage.map((m) => m.id).indexOf(mortgage.id);
      oldMortgageStage.splice(oldIndex, 1);
      mortgagesUpdated[mortgage.stage].unshift(mortgage);
      state.mortgages = mortgagesUpdated;
    },
    patcMortgage: (state, mortgage) => {
      const mortgagesUpdated = JSON.parse(JSON.stringify(state.mortgages));
      const oldMortgageStage = mortgagesUpdated[mortgage.stage];
      const oldIndex = oldMortgageStage.map((m) => m.id).indexOf(mortgage.id);
      if (oldIndex === -1) return;
      oldMortgageStage.splice(oldIndex, 1, mortgage);
      state.mortgages = mortgagesUpdated;
    },
    pushMortgage: (state, mortgage) => {
      const mortgagesUpdated = JSON.parse(JSON.stringify(state.mortgages));
      mortgagesUpdated[mortgage.stage].push(mortgage);
      state.mortgages = mortgagesUpdated;
    },
    removeMortgage: (state, mortgage) => {
      const mortgagesUpdated = JSON.parse(JSON.stringify(state.mortgages));
      const mortgagesCountUpdated = JSON.parse(JSON.stringify(state.mortgagesCount));
      const indexOfRemoved = mortgagesUpdated[mortgage.stage].map(e => e.id).indexOf(mortgage.id);
      mortgagesUpdated[mortgage.stage].splice(indexOfRemoved, 1);
      mortgagesCountUpdated[mortgage.stage] -= 1;
      state.mortgages = mortgagesUpdated;
      state.mortgagesCount = mortgagesCountUpdated;
    },
    moveMortgageFromStageToStage: (state, mortgage) => {
      const mortgagesUpdated = JSON.parse(JSON.stringify(state.mortgages));
      const mortgagesCountUpdated = JSON.parse(JSON.stringify(state.mortgagesCount));
      mortgagesCountUpdated[mortgage.stage] += 1;
      mortgagesUpdated[mortgage.stage].push(mortgage);
      const indexOfMoved = mortgagesUpdated[mortgage.oldStage].map(e => e.id).indexOf(mortgage.id);
      mortgagesCountUpdated[mortgage.oldStage] -= 1;
      mortgagesUpdated[mortgage.oldStage].splice(indexOfMoved, 1);
      delete mortgage.oldStage;
      state.mortgagesCount = mortgagesCountUpdated;
      state.mortgages = mortgagesUpdated;
    },
    setMortgagesCounts: (state, counts) => {
      state.mortgagesCount = counts;
    },
    setMortgagesCountByStage: (state, mortgages) => {
      const mortgagesUpdated = JSON.parse(JSON.stringify(state.mortgagesCount));
      mortgagesUpdated[mortgages.stage] = mortgages.count;
      state.mortgagesCount = mortgagesUpdated;
    },
    resetMortgagesFilters: (state) => {
      state.filter = {
        created__gte: null,
        created__lt: null,
        page_size: 10,
        financnik: null,
        search: null,
        active_service: null,
        is_active: true,
      };
      state.pages = {
        prehrana: 1,
        zrusena: 1,
        pozastavena: 1,
        vyber_riesenia: 1,
        podpis_ziadosti: 1,
        kompletizacia_podkladov: 1,
        schvalovanie: 1,
        servis: 1,
        cerpana: 1,
      };
    },
    setMortgagesFilter: (state, data) => {
      state.filters[data.key] = data.value;
    },
    setMortgagesFilters: (state, data) => {
      state.filters = data;
    },
    setStagePage: (state, pagesInfo) => {
      state.pages[pagesInfo.stage] = pagesInfo.pages;
    },
    setStagePages: (state, pages) => {
      state.pages = pages;
    }
  },
  actions: {
    initializeMortgages: async ({commit, state}, expand = "coapplicant,applicant.client_profile") => {
      state.filters.search = null;
      const stages = Object.entries(state.pages);

      console.log(stages);

      const responses = await Promise.all(
        stages.map(async ([stage, pages]) => {
          const mortgageResponse = await getMortgages({
            ...state.filters,
            page_size: pages * 10,
            stage,
            page: 1,
            expand
          });

          return {
            stage,
            mortgages: mortgageResponse.results,
            count: mortgageResponse.count
          };
        })
      );

      for (const { stage, mortgages, count } of responses) {
        commit("setMortgages", { stage, results: mortgages });
        commit("setMortgagesCountByStage", { stage, count });
      }
    },
    fetchMortgages: async ({commit, state}, expand = "coapplicant,applicant.client_profile") => {
      const stages = Object.entries(state.pages);

      const results = await Promise.all(
        stages.map(async ([stage, pages]) => {
          const mortgageResponse = await getMortgages({
            ...state.filters,
            page_size: pages * 10,
            stage,
            page: 1,
            expand
          });

          return {
            stage,
            mortgages: mortgageResponse.results,
            count: mortgageResponse.count
          };
        })
      );

      for (const { stage, mortgages, count } of results) {
        if (!deepEqual(mortgages, state.mortgages, true)) {
          commit("setMortgages", { stage, results: mortgages });
          commit("setMortgagesCountByStage", { stage, count });
        }
      }
    },
    nextPageMortgages: async ({commit, state}, {stage, expand="coapplicant,applicant.client_profile"}) => {
      let pages = state.pages[stage];
      pages++;
      commit("setStagePage", {stage, pages});
      const mortgageResponse = await getMortgages({...state.filters, page_size: 10, stage, page: pages, expand});
      let mortgage = mortgageResponse.results;
      const mortgagesCount = mortgageResponse.count;
      // mortgage = reduceMortgages([mortgage])[0];
      commit("attachNextPageMortgages", {stage: stage, results: mortgage});
      commit("setMortgagesCountByStage", {stage: stage, count: mortgagesCount});
    },
    moveMortgageToDifferentStage: async  ({dispatch, commit}, mortgageInfo) => {
      commit("setRefreshMortgageAuto", false);
      const targetLabels = {
        prehrana: "medzi prehrané",
        zrusena: "medzi zrušené",
        pozastavena: "medzi pozastavené",
      };
      const targetLabel = targetLabels[mortgageInfo.stage] || "do zvoleného stavu";
      try {
        commit("switchMortgageBetweenStages", mortgageInfo);
        commit("appState/setSuccessMessage", {
          text: `Hypotéka bola úspešne presunutá ${targetLabel}.`,
          type: "success"
        }, {root: true});
        await patchMortgage({...mortgageInfo, applicant: mortgageInfo.applicant.id, coapplicant: mortgageInfo.coapplicant?.id}, mortgageInfo.id);
      } catch (e) {
        commit("switchMortgageBetweenStages", {...mortgageInfo, stage_old: mortgageInfo.stage, stage: mortgageInfo.stage_old});
        commit("appState/setSuccessMessage", {
          text: `Hypotéku sa nepodarilo presunúť ${targetLabel}.`,
          type: "error"
        }, {root: true});
      }
      commit("setRefreshMortgageAuto", true);
    },
    patcMortgage: async ({commit}, {mortgageInfo, expand}) => {
      commit("setRefreshMortgageAuto", false);
      try {
        const mortgage = await patchMortgage({...mortgageInfo}, mortgageInfo.id, expand);
        commit("patcMortgage", mortgage);
      } catch (e) {
        throw e
      } finally {
        commit("setRefreshMortgageAuto", true);
      }
    },
    fetchMortgage: async ({commit}, mortgageInfo) => {
      commit("setRefreshMortgageAuto", false);
      let mortgage = await getMortgageById(mortgageInfo.id, "coapplicant,applicant.client_profile");
      // mortgage = reduceMortgages([mortgage])[0];
      commit("updateMortgage", {mortgage, stage: mortgageInfo.stage});
      commit("setRefreshMortgageAuto", true);
    },
    postMortgage: async ({dispatch, commit}, mortgageInfo) => {
      commit("setRefreshMortgageAuto", false);
      commit("appState/setLoadingPage", true, {root: true});
      try {
        let mortgage = await postMortgage(mortgageInfo);
        mortgage = await getMortgageById(mortgage.id, "coapplicant,applicant.client_profile");
        commit("registerNewMortgage", mortgage);
        commit("appState/setSuccessMessage", {
          text: "Hypotéka bola úspešne vytvorená",
          type: "success"
        }, {root: true});
        return mortgage;
      } finally {
        commit("appState/setLoadingPage", false, {root: true});
        commit("setRefreshMortgageAuto", true);
      }
    },
  },
};

function reduceMortgages (mortgages) {
  if (mortgages.length === 0) return mortgages;
  const newMortgages = JSON.parse(JSON.stringify(mortgages));
  newMortgages.forEach((mortgage) => {
    const applicantDetailReduced = {
      id: mortgage.applicant_detail?.id,
      first_name: mortgage.applicant_detail?.first_name,
      last_name: mortgage.applicant_detail?.last_name,
      email: mortgage.applicant_detail?.email,
      financnik: mortgage.applicant_detail?.financnik,
      client_profile: mortgage.applicant_detail?.client_profile,
    }
    const coApplicantDetailReduced = {
      id: mortgage.coapplicant_detail?.id,
      first_name: mortgage.coapplicant_detail?.first_name,
      last_name: mortgage.coapplicant_detail?.last_name,
      email: mortgage.coapplicant_detail?.email,
      financnik: mortgage.coapplicant_detail?.financnik,
      client_profile: mortgage.coapplicant_detail?.client_profile,
    }
    mortgage.applicant_detail = applicantDetailReduced;
    mortgage.coapplicant_detail = coApplicantDetailReduced;
    delete mortgage.dti_cache
  });
  return newMortgages;
}
